import type { ReactNode } from "react";
import { memo } from "react";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";
import { QuickActionChips } from "../QuickActionChips";

type QuickActionsChipType = {
	label: string;
	type: string;
	tooltip: string;
	selected?: boolean;
	closeIcon?: string;
	onClose?: () => void;
};

type Props = {
	numChallenges: number;
	quickActionsChips: QuickActionsChipType[];
	onQuickActionPress: (type: string) => void;
	searchQuery?: string;
	sortButton?: ReactNode;
};

export const ChallengesHeader = memo(
	({
		numChallenges,
		quickActionsChips,
		onQuickActionPress,
		searchQuery,
		sortButton,
	}: Props) => (
		<Box>
			<QuickActionChips
				quickActionsChips={quickActionsChips}
				handleQuickActionPress={onQuickActionPress}
			/>
			<Box
				flexDirection="row"
				justifyContent="space-between"
				alignItems="center"
			>
				<CustomListSubheader>{numChallenges} Challenges</CustomListSubheader>
				{!searchQuery && sortButton}
			</Box>
		</Box>
	),
);

ChallengesHeader.displayName = "ChallengesHeader";
